import { Select } from "antd";
import { SelectProps } from "antd/lib";
import { unescape } from "lodash";
import ClearIcon from "./ClearIcon";
import {
  CustomFieldDataType,
  CustomFieldOption,
} from "@portal/types/entities/custom-field";
import { formatBooleanForDisplay } from "@portal/util/boolean-formatter";

interface SelectEditorCellProps {
  options: SelectProps["options"];
  value?: string;
  handleClear?: () => void;
  isLoading?: boolean;
  onChange?: (value: string) => void;
  dataType: CustomFieldDataType;
  customOptions: CustomFieldOption[];
  style?: React.CSSProperties;
  filterOption?: SelectProps["filterOption"];
  isEditable?: boolean;
}

export default function SelectEditorCell(props: SelectEditorCellProps) {
  const placeholderText = "Select a option...";

  // Process options to unescape labels
  const processOptions = () => {
    return props.options?.map((option) => {
      if (props.dataType === "BOOLEAN") {
        return {
          ...option,
          label: formatBooleanForDisplay(String(option.label)),
        };
      }
      return {
        ...option,
        label: unescape(String(option.label)),
      };
    });
  };

  const options = processOptions();

  // Handle select change
  const handleSelectChange = (value: unknown) => {
    props?.onChange?.(value as string);
  };

  // Handle clear
  const handleClear = () => {
    props?.handleClear?.();
  };

  // Process default value for boolean type
  const getDefaultValue = () => {
    if (props.dataType === "BOOLEAN" && props.value) {
      return formatBooleanForDisplay(String(props.value));
    }
    return props.value;
  };

  const SelectCustomField = (
    <Select
      placeholder={placeholderText}
      options={options}
      style={props.style}
      allowClear={{
        clearIcon: <ClearIcon onClick={handleClear} />,
      }}
      defaultValue={getDefaultValue()}
      loading={props.isLoading}
      onChange={handleSelectChange}
      variant={"outlined"}
      disabled={!props.isEditable}
    />
  );

  return <>{SelectCustomField}</>;
}
